import { capitalizeFirstLetter } from "shared/utils/string-utils";

import { AccordionSize, AccordionVariant } from "./types";

export const getSizeClassName = (size: AccordionSize) =>
  `MuiAccordion-size${capitalizeFirstLetter(size)}`;

export const getVariantClassName = (variant: AccordionVariant) =>
  `MuiAccordion-variant${capitalizeFirstLetter(variant)}`;

export const getDetailsVariantClassName = (variant: AccordionVariant) =>
  `MuiAccordionDetails-variant${capitalizeFirstLetter(variant)}`;
